var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1514",
    "data-name": "Group 1514",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.6,
    height: 24,
    viewBox: "0 0 21.6 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_216",
    "data-name": "Rectangle 216",
    width: 21.6,
    height: 24,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1514-2",
    "data-name": "Group 1514",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M19.2,1.92a.48.48,0,0,1,.48.48V21.6a.48.48,0,0,1-.48.48H2.4a.48.48,0,0,1-.48-.48V2.4a.48.48,0,0,1,.48-.48ZM19.2,0H2.4A2.4,2.4,0,0,0,0,2.4V21.6A2.4,2.4,0,0,0,2.4,24H19.2a2.4,2.4,0,0,0,2.4-2.4V2.4A2.4,2.4,0,0,0,19.2,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M31.56,22.92h-9.6a.96.96,0,0,1,0-1.92h9.6a.96.96,0,1,1,0,1.92",
    transform: "translate(-15.96 -15.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M31.56,47.92h-9.6a.96.96,0,1,1,0-1.92h9.6a.96.96,0,1,1,0,1.92",
    transform: "translate(-15.96 -34.96)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M31.56,72.92h-9.6a.96.96,0,0,1,0-1.92h9.6a.96.96,0,1,1,0,1.92",
    transform: "translate(-15.96 -53.96)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report_icon.3cb88c99185e16e09fc666b08da1b080.svg";
export { ForwardRef as ReactComponent };